<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 实名相关</el-breadcrumb-item>
                <el-breadcrumb-item>生成玩家账号</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <!-- 添加或修改参数配置对话框 -->
            <el-row :gutter='10'>
                <el-col :span='12'>
                    <el-form label-position="left">
                        <el-form-item label="账号前缀">
                            <el-input @input='createUserArr' v-model='autoGenerateRule.accountPrefix' placeholder='请输入账号前缀' ></el-input>
                        </el-form-item>
                        <el-form-item label="账号后缀">
                            <el-input @input='createUserArr' v-model='autoGenerateRule.accountSuffix' placeholder='请输入账号后缀' ></el-input>
                        </el-form-item>
                        <el-form-item label="密码">
                            <el-input @input='createUserArr' v-model='autoGenerateRule.password' placeholder='请输入密码' ></el-input>
                        </el-form-item>
                        <el-form-item label="生成账号数量">
                            <el-input @input='createUserArr' type='number' min='0' v-model='autoGenerateRule.accountNumber' placeholder='请输入账号数量' ></el-input>
                        </el-form-item>
                        <el-form-item label="初始开始值">
                            <el-input @input='createUserArr' type='number' v-model='autoGenerateRule.startNumber' min='0' placeholder='例如生成5个,初始开始值为6,那么第一个账号为xxx7' ></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span='12'>
                    <el-table max-height='300' :cell-style="{ textAlign: 'center' }" :data='generateUserArr'>
                        <el-table-column align='center' label='Account' prop='account' />
                        <el-table-column align='center' label='Password' prop='password' />
                    </el-table>
                </el-col>
            </el-row>
            
            <el-button type='primary' @click='handleAutoGeneratePlayer'>生成</el-button>
            
            <el-dialog :title='title' :visible.sync='open' append-to-body width='40%'>
                <el-table :cell-style="{ textAlign: 'center' }" :data='successGenerateUserArr'>
                    <el-table-column align='center' label='账号' prop='account' />
                    <el-table-column align='center' label='密码' prop='password' />
                </el-table>
            </el-dialog>
        </div>
    </section>
</template>

<script>


import { message } from '@/utils/message';
import { copyContent } from '@/utils/string/cottonPlugin';
import CottonDynamicForm from '../../../component/CottonDynamicForm.vue';
import { queryProjectInfoList } from '../../../api/ProjectInfo';
import { cottonUserApi } from '../../../api/Account/userCotton';
import { confirm } from '@/utils/confirm';

export default {
    name: 'GameDetail',
    components: { CottonDynamicForm },
    data() {
        return {
            activeName: 'manually',
            manuallyUserInfoArr: {
                userArr: ''
            },
            manuallyUserInfo: {},
            generateUserArr: [],
            successGenerateUserArr: [],
            open: false,
            title: '确认',
            autoGenerateRule: {
                accountPrefix: '',
                accountSuffix: '',
                password: 'Cotton888',
                accountNumber: 1,
                startNumber: 0
            },
            projectInfoList: [],
            accountLength: 15,
            passwordLength: 15,
            numberArr: [0,1,2,3,4,5,6,7,8,9],
            charArr: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
                'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
        };
    },
    created() {
        this.getList()
    },
    computed: {
    
    },
    methods: {
        getList() {
            queryProjectInfoList({pageSize: 100000}).then(result => {
                if (result.code === 200) {
                    this.projectInfoList = result.data.result
                }
            })
        },
        getDynamicJsonObject(plays) {
            this.manuallyUserInfo = plays
        },
        async handleManuallyPlayerAccount() {
            this.generateUserArr = []
            for (let key in this.manuallyUserInfo) {
                this.generateUserArr.push({
                    account: key,
                    password: this.manuallyUserInfo[key]
                })
            }
        },
        async handleManuallyGeneratePlayer() {
            await this.handleManuallyPlayerAccount()
            if (this.generateUserArr.length === 0) {
                message.error("没有账号")
                return
            }
            this.open = true
        },
        async handleAutoGeneratePlayer() {
            if (this.autoGenerateRule.accountNumber <= 0) {
                message.warning("账号数量必须大于0")
                return
            }
            
            if ((this.autoGenerateRule.accountPrefix.length
                + this.autoGenerateRule.accountSuffix.length)
                + (this.autoGenerateRule.accountNumber + "").length > this.accountLength) {
                message.warning("账号长度不能超过" + this.accountLength)
                return
            }
            if (this.autoGenerateRule.password.length > this.passwordLength) {
                message.warning("密码长度不能超过" + this.passwordLength)
                return
            }
            // 计算剩余字段长度
            await this.createUserArr()
            confirm.warning(`确定一次性创建${this.generateUserArr.length}个用户?`, null, () => {
                cottonUserApi.batchInsertUserCotton({userCottonList: this.generateUserArr}).then(result => {
                    if (result.code === 200) {
                        this.successGenerateUserArr = []
                        this.title = '系统最终生成成功的玩家账号为'
                        this.open = true
                        this.successGenerateUserArr = result.data
                        message.success(`预生成个数${this.generateUserArr.length}, 成功个数: ${result.data.length}`)
                        
                        let arr = []
                        this.successGenerateUserArr.forEach((item, index) => {
                            arr.push({
                                account: item.account,
                                password: item.password
                            })
                            if (index === this.generateUserArr.length - 1) {
                                this.exportToCSV(arr)
                            }
                        })
                    }
                })
            })
        },
        submitForm() {
        
        },
        copyAllAccountInfo() {
            let msg = ''
            for (let i = 0; i < this.generateUserArr.length; i++) {
                let data = this.generateUserArr[i]
                msg = msg + "account: " + data.account + "   password: " + data.password + "\n"
                if (i === this.generateUserArr.length - 1) {
                    copyContent(msg)
                }
            }
        },
        async createUserArr() {
            return new Promise((resolve, reject) => {
                this.generateUserArr = []

                let prefix = this.autoGenerateRule.accountPrefix
                let suffix = this.autoGenerateRule.accountSuffix
                if (!prefix) {
                    prefix = ''
                }
                if (!suffix) {
                    suffix = ''
                }
                if ((prefix.length + suffix.length) === 0) {
                    resolve()
                    return
                }

                if (this.autoGenerateRule.accountNumber > 1) {
                    let startNumber = parseInt(this.autoGenerateRule.startNumber)
                    let endNumber = parseInt(this.autoGenerateRule.accountNumber)

                    if (startNumber === 0) {
                        startNumber = 1
                    }else {
                        endNumber = endNumber + startNumber
                    }
                    
                    for (let i = startNumber; i <= endNumber; i++) {
                        let username = prefix + i + suffix
                        this.generateUserArr.push({
                            account: username,
                            password: this.autoGenerateRule.password,
                            tableId: i
                        })
                        if (i === endNumber) {
                            resolve()
                        }
                    }
                }else {
                    this.generateUserArr.push({
                        account: prefix + suffix,
                        password: this.autoGenerateRule.password,
                        tableId: 1
                    })
                    resolve()
                }
            })
        },
        exportToCSV(data) {
            let filename = `${new Date().getTime()}.csv`
            // 1. 将数据转换为CSV格式
            let csvContent = '';
            
            // 如果数据是对象数组，先添加表头
            if (Array.isArray(data) && data.length > 0 && typeof data[0] === 'object') {
                csvContent = Object.keys(data[0]).join(',') + '\n';
            }
            
            // 添加数据行
            if (Array.isArray(data)) {
                data.forEach(row => {
                    if (typeof row === 'object') {
                        const values = Object.values(row).map(value => {
                            // 处理包含逗号、引号或换行符的字段
                            const stringValue = String(value);
                            if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
                                return `"${stringValue.replace(/"/g, '""')}"`;
                            }
                            return stringValue;
                        });
                        csvContent += values.join(',') + '\n';
                    } else {
                        csvContent += row + '\n';
                    }
                });
            }
            
            // 2. 创建Blob对象
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            
            // 3. 创建下载链接
            if (navigator.msSaveBlob) { // 兼容IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                const link = document.createElement('a');
                
                // 创建URL
                const url = URL.createObjectURL(blob);
                
                // 设置链接属性
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                
                // 添加到DOM
                document.body.appendChild(link);
                
                // 触发点击事件
                link.click();
                
                // 清理
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }
        }
    },
};
</script>
<style>

</style>